export default "__VITE_ASSET__4aba7115__"